<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import { useAnalysisStore } from '@/store/modules/analysis'
import {
  removeAsterisk,
  splitKeywordParts,
  splitBySentence,
  parseHashTags,
  splitCommaSeparatedWords,
} from '@/composables/splitSentence'

const props = defineProps({
  pData: Object,
  userName: String,
  isMobile: Boolean,
})
const store = useAnalysisStore()
// const userName = computed(() => store.userName)
onMounted(() => {
  // pData.value = store.analysisResult;
})

const colorData = computed(() => splitBySentence(props.pData.개운방안상세.색상특징))
const colorKeyword = computed(() => parseHashTags(props.pData.개운방안상세.색상키워드))
const placeData = computed(() => splitBySentence(props.pData.개운방안상세.공간특징))
const placeKeyword = computed(() => parseHashTags(props.pData.개운방안상세.공간키워드))
const foodData = computed(() => splitBySentence(props.pData.개운방안상세.음식특징))
const foodKeyword = computed(() => parseHashTags(props.pData.개운방안상세.음식키워드))
const exerciseData = computed(() => splitBySentence(props.pData.개운방안상세.운동특징))
const exerciseKeyword = computed(() => parseHashTags(props.pData.개운방안상세.운동키워드))
const clothesData = computed(() => splitBySentence(props.pData.개운방안상세.의상특징))
const clothesKeyword = computed(() => parseHashTags(props.pData.개운방안상세.의상키워드))
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="personality-wrapper">
          <div class="person-content-box">
            <div class="content__title">☺️ 일상에서 활용하는 방법</div>
            <span class="content__body-txt">
              일상 속에서 편하게 시도할 수 있는 방법들을 모았어요. 가볍게 시작해보세요.
            </span>
          </div>
          <div 
            class="personality-reco-wrapper"
            :class="{mobile: isMobile}"
          >
            <div class="person-reco__box">
              <div class="left-gray-box">
                <div class="gray-box__inner">
                  <div class="gray-box__img color"></div>
                  <span class="gray-box__txt"> 색상 </span>
                </div>
              </div>
              <div class="right-desc-box">
                <div v-for="(sentence, idx) in colorData" :key="idx">
                  <span class="content__body-txt">
                    <template v-for="(part, pIdx) in splitKeywordParts(sentence)" :key="pIdx">
                      <span v-if="part.isKeyword" class="p-keyword">{{ part.text }}</span>
                      <template v-else>{{ part.text }}</template>
                    </template>
                  </span>
                </div>
                <div class="right-desc-keywords">
                  <div v-for="(word, idx) in colorKeyword" :key="idx" class="desc-keyword">
                    {{ word }}
                  </div>
                </div>
              </div>
            </div>
            <div class="personality-divider" />
            <div class="person-reco__box">
              <div class="left-gray-box">
                <div class="gray-box__inner">
                  <div class="gray-box__img place"></div>
                  <span class="gray-box__txt"> 공간 </span>
                </div>
              </div>
              <div class="right-desc-box">
                <div v-for="(sentence, idx) in placeData" :key="idx">
                  <span class="content__body-txt">
                    <template v-for="(part, pIdx) in splitKeywordParts(sentence)" :key="pIdx">
                      <span v-if="part.isKeyword" class="p-keyword">{{ part.text }}</span>
                      <template v-else>{{ part.text }}</template>
                    </template>
                  </span>
                </div>
                <div class="right-desc-keywords">
                  <div v-for="(word, idx) in placeKeyword" :key="idx" class="desc-keyword">
                    {{ word }}
                  </div>
                </div>
              </div>
            </div>
            <div class="personality-divider" />
            <div class="person-reco__box">
              <div class="left-gray-box">
                <div class="gray-box__inner">
                  <div class="gray-box__img food"></div>
                  <span class="gray-box__txt"> 음식 </span>
                </div>
              </div>
              <div class="right-desc-box">
                <div v-for="(sentence, idx) in foodData" :key="idx">
                  <span class="content__body-txt">
                    <template v-for="(part, pIdx) in splitKeywordParts(sentence)" :key="pIdx">
                      <span v-if="part.isKeyword" class="p-keyword">{{ part.text }}</span>
                      <template v-else>{{ part.text }}</template>
                    </template>
                  </span>
                </div>
                <div class="right-desc-keywords">
                  <div v-for="(word, idx) in foodKeyword" :key="idx" class="desc-keyword">
                    {{ word }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="personality-wrapper">
          <div 
            class="personality-reco-wrapper"
            :class="{mobile: isMobile}"
          >
            <div class="person-reco__box">
              <div class="left-gray-box">
                <div class="gray-box__inner">
                  <div class="gray-box__img exercise"></div>
                  <span class="gray-box__txt"> 운동 </span>
                </div>
              </div>
              <div class="right-desc-box">
                <div v-for="(sentence, idx) in exerciseData" :key="idx">
                  <span class="content__body-txt">
                    <template v-for="(part, pIdx) in splitKeywordParts(sentence)" :key="pIdx">
                      <span v-if="part.isKeyword" class="p-keyword">{{ part.text }}</span>
                      <template v-else>{{ part.text }}</template>
                    </template>
                  </span>
                </div>
                <div class="right-desc-keywords">
                  <div v-for="(word, idx) in exerciseKeyword" :key="idx" class="desc-keyword">
                    {{ word }}
                  </div>
                </div>
              </div>
            </div>
            <div class="personality-divider" />
            <div class="person-reco__box">
              <div class="left-gray-box">
                <div class="gray-box__inner">
                  <div class="gray-box__img clothes"></div>
                  <span class="gray-box__txt"> 의상 </span>
                </div>
              </div>
              <div class="right-desc-box">
                <div v-for="(sentence, idx) in clothesData" :key="idx">
                  <span class="content__body-txt">
                    <template v-for="(part, pIdx) in splitKeywordParts(sentence)" :key="pIdx">
                      <span v-if="part.isKeyword" class="p-keyword">{{ part.text }}</span>
                      <template v-else>{{ part.text }}</template>
                    </template>
                  </span>
                </div>
                <div class="right-desc-keywords">
                  <div v-for="(word, idx) in clothesKeyword" :key="idx" class="desc-keyword">
                    {{ word }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
